import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { MainBoard } from "../../componet/MainBoard";
import { Login } from "../../view/auth/shared/Login";
import {Index} from "../../view/public/Index"
import {Conocenos} from "../../view/public/Conocenos";
import { Guard } from "../../segurity/Guard";
import { Error4040 } from "../../view/public/Error4040";
import { Index2 } from "../../view/public/Index2";

const LazyMainBoard = lazy(() =>
  import("../../componet/MainBoard").then(() => ({ default: MainBoard }))
);

const LazyLogin = lazy(() =>
  import("../../view/auth/shared/Login").then(() => ({ default: Login }))
);
const LazyIndex = lazy(() =>
  import("../../view/public/Index").then(() => ({ default: Index }))
);
const LazyIndex2 = lazy(() =>
  import("../../view/public/Index2").then(() => ({ default: Index2 }))
);
const LazyConocenos = lazy(() =>
  import("../../view/public/Conocenos").then(() => ({ default: Conocenos }))
);
const NotFound = lazy(() =>
  import("../../view/public/Error4040").then(() => ({ default: Error4040 }))
);

export const CompleteRouting = () => {
  return (
    <Routes>
      <Route element={<Guard />}>
        <Route path="/home/*" element={<LazyMainBoard />} />
      </Route>
      <Route path="/Conocenos" element={<LazyConocenos />} />
      <Route path="/login" element={<LazyLogin />} />
      <Route path="/" element={<LazyIndex />} />
      <Route path="/Indes" element={<LazyIndex2 />} />

    <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
